<template>
	<v-container fluid id="consultas-container" class="d-flex flex-column align-start" style="flex: 1;width: 100%;">
		<v-btn-toggle style="width: 100%;" v-if="!$vuetify.breakpoint.mobile">
			<GlobalNewButton class="mr-2"/>
			<v-btn class="custom-button-consultas" :class="selectedType === 2 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_rdi'])"
				@click="changeListing(2)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Mis Reuniones/Minutas</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Participante</p>
					</div>
				</div>
			</v-btn>
			<!-- <v-btn class="custom-button-consultas" :class="selectedType === 3 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_rdi'])"
				@click="changeListing(3)">
				<div class="d-flex align-start">
					<v-icon>mdi-text-box-check-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Reuniones/Minutas</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Del Proyecto</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="selectedType === 5 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_rdi'])"
				@click="changeListing(5)">
				<div class="d-flex align-start">
					<v-icon>mdi-file-document-edit-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
					</div>
				</div>
			</v-btn> -->
		</v-btn-toggle>
    <v-menu offset-y v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
					rounded
					color="#2D4B95"
					dark
					small
					block
          v-bind="attrs"
          v-on="on"
        >
          Seleccione Acción
        </v-btn>
      </template>
			<div class="d-flex flex-column pa-2 white" style="gap: 5px;">
				<GlobalNewButton :fullWidth="true"/>
				<v-divider class="my-1"></v-divider>
				<v-btn class="custom-button-consultas" :class="selectedType === 2 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_rdi'])"
					@click="changeListing(2)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Mis Reuniones/Minutas</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Participante</p>
						</div>
					</div>
				</v-btn>
				<!-- <v-btn class="custom-button-consultas" :class="selectedType === 3 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_rdi'])"
					@click="changeListing(3)">
					<div class="d-flex align-start">
						<v-icon>mdi-text-box-check-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Reuniones/Minutas</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Del Proyecto</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="selectedType === 5 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_rdi'])"
					@click="changeListing(5)">
					<div class="d-flex align-start">
						<v-icon>mdi-file-document-edit-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
						</div>
					</div>
				</v-btn> -->
			</div>
    </v-menu>
		<div class="d-flex flex-column align-start mt-2" style="flex: 1;width: 100%;">
			<MeetingsCalendarView
				ref="meetingsCalendar"
				v-if="(selectedType === 2 || selectedType === 3) && !$vuetify.breakpoint.mobile"
				:ended="selectedType === 3"/>
			<ListadoBorradores
				v-if="selectedType === 5"
				:draftType="13"
				@loadDraft="loadDraft"
			/>
		</div>
	</v-container>
</template>

<script>
import MeetingsCalendarView from './MeetingsCalendarView'
import ListadoBorradores from '@/components/Globals/Helpers/ListadoBorradores'
import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'

export default {
	name: 'MeetingsContainer',
	components: { MeetingsCalendarView, ListadoBorradores, GlobalNewButton },
	data: () => ({
		createTareaModal: false,
	}),
	computed: {
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		},
		selectedType() {
			return this.$store.meetingStore.state.selectedType
		}
	},
	watch: {
		selectedProject(newVal, oldVal) {
			if(!newVal?.id || newVal.id === oldVal?.id) return
			this.getMeetingsList()
		}
	},
	mounted() {
		this.getMeetingsList()
	},
	methods: {
		getProjectId() {
			if(this.$store.projectsStore.state.selectedProject) {
				return this.$store.projectsStore.state.selectedProject.id
			}
			return parseInt(localStorage.getItem('selectedProjectID'))
		},
		getMeetingsList() {
			const project_id = this.getProjectId()
			if(project_id) {
				this.$store.meetingStore.dispatch('getMyMeetings', { project_id })
			}
		},
		loadDraft(draft) {
			const draftType = draft.raw_type
			this.$store.meetingStore.commit('setDraftToLoad', draft)
			if(draftType === 2) {
				this.$store.meetingStore.commit('setCreateMeetingModal', true)
			} else if(draftType === 6 && draft.morphable_id) {
				this.viewMeeting(draft.morphable_id)
			}
		},
		async viewMeeting(meeting_id) {
			this.$store.meetingStore.commit('setCurrentMeeting', { loading: true })
			const { getMeeting } = await import('@/helpers/api/meetings')
			const res = await getMeeting({ meeting_id })
			if(res && res.code === 200) {
				const meetingData = res.meeting
				meetingData.prev_seen_by_me = null
				this.$store.meetingStore.commit('setCurrentMeeting', meetingData)
			} else if(res && res.code === 403) {
				this.$store.meetingStore.commit('setCurrentMeeting', null)
			}
		},
		async changeListing(selected) {
			if(this.selectedType !== selected) {
				this.$store.meetingStore.commit('setSelectedType', selected)
				await this.$nextTick()
				if(this.$refs.meetingsCalendar) {
					this.$refs.meetingsCalendar.loadMeetings()
				} else {
					this.getMeetingsList()
				}
			}
		},
	}
}
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
		text-align: left;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}
</style>